import React from 'react';
import { useLoader } from 'src/common/context/loader.context';
import { LoaderSquare } from './loaderSquare.other';

export const GlobalLoader: React.FC = () => {
  const { isLoading } = useLoader();

  return <LoaderSquare overlay={true} loading={isLoading} />;
}; 